import connectedComponent from './ToolsOverlay';

export default connectedComponent;